import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../module_mechanics/Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faEye, faTimesCircle, faDollarSign, faBalanceScale, faCalculator,
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone, faNetworkWired, faPercent,
    faEnvelope, faMapMarkerAlt, faTag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faTruck, faBuilding, faGlobe, faUserTag, faStickyNote, faExternalLinkAlt,
    faBoxes, faBox, faCubes, faBoxOpen, faLayerGroup, faIndustry, faHashtag, faBarcode,
    faCreditCard, faPalette, faRulerCombined, faWarehouse, faCubes as faCubesIcon, faTag as faTagIcon,
    faLink, faShieldAlt, faBoxes as faBoxesIcon, faLayerGroup as faLayerGroupIcon,
    faPlusCircle, faClone
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// This must be the same server file as the PHP file supplied with this list.
const PRODUCTS_API_URL = 'https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_products.php';

// ============================================
// SHARED TRANSLATOR FOR PRODUCT LIST
// ============================================
const createProductListTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Products List': 'مصنوعات کی فہرست',
                'All products details are below': 'تمام مصنوعات کی تفصیلات نیچے ہیں',
                'Product Name': 'پروڈکٹ کا نام',
                'Category': 'زمرہ',
                'Company': 'کمپنی',
                'Supplier': 'سپلائر',
                'Color': 'رنگ',
                'Size': 'سائز',
                'Batch Number': 'بیچ نمبر',
                'Barcode': 'بارکوڈ',
                'Quantity': 'مقدار',
                'BQuantity': 'بلک مقدار',
                'Cost Price': 'لاگت قیمت',
                'Selling Price': 'فروخت قیمت',
                'Unit': 'یونٹ',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search products...': 'مصنوعات تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'Product Details': 'پروڈکٹ کی تفصیلات',
                'Stock Information': 'اسٹاک کی معلومات',
                'Packing Information': 'پیکنگ کی معلومات',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view products': 'براہ کرم مصنوعات دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Products': 'مصنوعات',
                'Shop': 'شاپ',
                'View': 'دیکھیں',
                'Update Product': 'پروڈکٹ اپڈیٹ کریں',
                'Updating...': 'اپڈیٹ ہو رہا ہے...',
                'Product updated successfully': 'پروڈکٹ کامیابی سے اپڈیٹ ہو گئی',
                'Error updating product': 'پروڈکٹ اپڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Product Report': 'پروڈکٹ رپورٹ',
                'Inventory Report': 'انوینٹری رپورٹ',
                'Total Products': 'کل مصنوعات',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Stock Status': 'اسٹاک کی حیثیت',
                'Low Stock': 'کم اسٹاک',
                'Out of Stock': 'اسٹاک ختم',
                'In Stock': 'اسٹاک میں ہے',
                'Packing Type': 'پیکنگ کی قسم',
                'Sub Packing': 'ذیلی پیکنگ',
                'Items/Pack': 'آئٹمز/پیک',
                'Cost/Pack': 'لاگت/پیک',
                'Price/Pack': 'قیمت/پیک',
                'Cost/Unit': 'لاگت/یونٹ',
                'Price/Unit': 'قیمت/یونٹ',
                'Stock Value': 'اسٹاک ویلیو',
                'Expiry Date': 'میعاد ختم ہونے کی تاریخ',
                'Low Stock Alert': 'کم اسٹاک الرٹ',
                'Unit of Measure': 'پیمائش کی اکائی',
                'Cost Per Pack': 'فی پیک لاگت',
                'Sell Price Per Unit': 'فی یونٹ فروخت قیمت',
                'Total Quantity': 'کل مقدار',
                'Sub Packing Type': 'ذیلی پیکنگ کی قسم',
                'Items Per Pack': 'فی پیک اشیاء',
                'Cost Per Unit': 'فی یونٹ لاگت',
                'Sell Per Pack': 'فی پیک فروخت قیمت',
                'to': 'تک',
                'per page': 'فی صفحہ',
                'Show': 'دکھائیں',
                'Supplier Name': 'سپلائر کا نام',
                'Bulk Edit': 'بلک ترمیم',
                'Single Edit': 'انفرادی ترمیم',
                'Edit Mode': 'ترمیم کا طریقہ',
                'Common Fields': 'مشترکہ فیلڈز',
                'RQ (Rows)': 'آر کیو (صفیں)',
                'Apply to all selected products': 'تمام منتخب مصنوعات پر لاگو کریں',
                'Add Row': 'صف شامل کریں',
                'Remove Row': 'صف ہٹائیں',
                'New Product Row': 'نیا پروڈکٹ صف'
            },
            'ar': {
                'Products List': 'قائمة المنتجات',
                'All products details are below': 'جميع تفاصيل المنتجات أدناه',
                'Product Name': 'اسم المنتج',
                'Category': 'الفئة',
                'Company': 'الشركة',
                'Supplier': 'المورد',
                'Color': 'اللون',
                'Size': 'الحجم',
                'Batch Number': 'رقم الدفعة',
                'Barcode': 'الباركود',
                'Quantity': 'الكمية',
                'BQuantity': 'كمية الصندوق',
                'Cost Price': 'سعر التكلفة',
                'Selling Price': 'سعر البيع',
                'Unit': 'الوحدة',
                'Actions': 'الإجراءات',
                'Added By': 'أضيف بواسطة',
                'Search products...': 'بحث عن منتجات...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'Close': 'إغلاق',
                'Save Changes': 'حفظ التغييرات',
                'Cancel': 'إلغاء',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'All': 'الكل',
                'Product Details': 'تفاصيل المنتج',
                'Stock Information': 'معلومات المخزون',
                'Packing Information': 'معلومات التغليف',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view products': 'الرجاء اختيار متجر لعرض المنتجات',
                'S.No': 'رقم',
                'Products': 'المنتجات',
                'Shop': 'متجر',
                'View': 'عرض',
                'Update Product': 'تحديث المنتج',
                'Updating...': 'جاري التحديث...',
                'Product updated successfully': 'تم تحديث المنتج بنجاح',
                'Error updating product': 'خطأ في تحديث المنتج',
                'Confirm Delete': 'تأكيد الحذف',
                'Yes, Delete': 'نعم، حذف',
                'No, Cancel': 'لا، إلغاء',
                'Portrait': 'عمودي',
                'Landscape': 'أفقي',
                'A4': 'A4',
                'Letter': 'رسالة',
                'Legal': 'قانوني',
                'A5': 'A5',
                'Product Report': 'تقرير المنتجات',
                'Inventory Report': 'تقرير المخزون',
                'Total Products': 'إجمالي المنتجات',
                'Generated': 'تم الإنشاء',
                'Report ID': 'معرف التقرير',
                'Generated by': 'تم الإنشاء بواسطة',
                'Shop Code': 'رمز المتجر',
                'FILTERS APPLIED': 'المرشحات المطبقة',
                'Search': 'بحث',
                'From': 'من',
                'To': 'إلى',
                'Page': 'صفحة',
                'Stock Status': 'حالة المخزون',
                'Low Stock': 'مخزون منخفض',
                'Out of Stock': 'نفد المخزون',
                'In Stock': 'متوفر',
                'Packing Type': 'نوع التغليف',
                'Sub Packing': 'التغليف الفرعي',
                'Items/Pack': 'القطع/العبوة',
                'Cost/Pack': 'التكلفة/العبوة',
                'Price/Pack': 'السعر/العبوة',
                'Cost/Unit': 'التكلفة/الوحدة',
                'Price/Unit': 'السعر/الوحدة',
                'Stock Value': 'قيمة المخزون',
                'Expiry Date': 'تاريخ الانتهاء',
                'Low Stock Alert': 'تنبيه المخزون المنخفض',
                'Unit of Measure': 'وحدة القياس',
                'Cost Per Pack': 'التكلفة لكل عبوة',
                'Sell Price Per Unit': 'سعر البيع لكل وحدة',
                'Total Quantity': 'الكمية الإجمالية',
                'Sub Packing Type': 'نوع التغليف الفرعي',
                'Items Per Pack': 'القطع لكل عبوة',
                'Cost Per Unit': 'التكلفة لكل وحدة',
                'Sell Per Pack': 'البيع لكل عبوة',
                'to': 'إلى',
                'per page': 'لكل صفحة',
                'Show': 'عرض',
                'Supplier Name': 'اسم المورد',
                'Bulk Edit': 'تعديل جماعي',
                'Single Edit': 'تعديل فردي',
                'Edit Mode': 'وضع التعديل',
                'Common Fields': 'الحقول المشتركة',
                'RQ (Rows)': 'آر كيو (صفوف)',
                'Apply to all selected products': 'تطبيق على جميع المنتجات المحددة',
                'Add Row': 'إضافة صف',
                'Remove Row': 'إزالة صف',
                'New Product Row': 'صف منتج جديد'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        productList: 'Products List',
        formDetails: 'All products details are below',
        products: 'Products',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search products...',
        refresh: 'Refresh',
        loadingUserData: 'Loading your product data...',
        selectShop: 'Please select a shop to view products',
        productName: 'Product Name',
        warranty: 'Warranty',
        category: 'Category',
        company: 'Company',
        supplierName: 'Supplier',
        color: 'Color',
        size: 'Size',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        quantity: 'Quantity',
        bquantity: 'BQuantity',
        costPrice: 'Cost Price',
        sellingPrice: 'Selling Price',
        unit: 'Unit',
        actions: 'Actions',
        addedBy: 'Added By',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        productNameFilter: 'Product Name',
        categoryFilter: 'Category',
        companyFilter: 'Company Name',
        colorFilter: 'Color',
        sizeFilter: 'Size',
        batchFilter: 'Batch Number',
        barcodeFilter: 'Barcode',
        addedByFilter: 'Added By',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        productDetails: 'Product Details',
        stockInfo: 'Stock Information',
        packingInfo: 'Packing Information',
        editProduct: 'Edit Product',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this product?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        productReport: 'Product Report',
        inventoryReport: 'Inventory Report',
        totalProducts: 'Total Products',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        stockStatus: 'Stock Status',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        inStock: 'In Stock',
        packingType: 'Packing Type',
        subPackingType: 'Sub Packing Type',
        itemsPerPack: 'Items/Pack',
        costPerPack: 'Cost/Pack',
        sellPerPack: 'Price/Pack',
        costPerUnit: 'Cost/Unit',
        sellPerUnit: 'Price/Unit',
        stockValue: 'Stock Value',
        expiryDate: 'Expiry Date',
        lowStockAlert: 'Low Stock Alert',
        unitOfMeasure: 'Unit of Measure',
        totalQuantity: 'Total Quantity',
        show: 'Show',
        perPage: 'per page',
        bulkEdit: 'Bulk Edit',
        singleEdit: 'Single Edit',
        editMode: 'Edit Mode',
        commonFields: 'Common Fields',
        rqRows: 'RQ (Rows)',
        applyToAll: 'Apply to all selected products',
        addRow: 'Add Row',
        removeRow: 'Remove Row',
        newProductRow: 'New Product Row'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const productListTranslator = createProductListTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };
    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations?.success || 'Success';
            case 'error': return translations?.error || 'Error';
            case 'warning': return translations?.warning || 'Warning';
            default: return '';
        }
    };
    if (!toast.show) return null;
    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon"><FontAwesomeIcon icon={getIconForType(toast.type)} /></div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Custom Dropdown Component
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [isHovering, setIsHovering] = useState(false);
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const menuRef = useRef(null);
    const hoverTimeoutRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        if (!isHovering) {
            setSearchTerm(displayValue);
        }
    }, [displayValue, isHovering]);

    useEffect(() => {
        if (isOpen) {
            const event = new CustomEvent('dropdownOpened', { detail: { id: label } });
            window.dispatchEvent(event);
        }
    }, [isOpen, label]);

    useEffect(() => {
        const handleDropdownOpened = (event) => {
            if (event.detail && event.detail.id !== label) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        window.addEventListener('dropdownOpened', handleDropdownOpened);
        return () => window.removeEventListener('dropdownOpened', handleDropdownOpened);
    }, [label]);

    const filteredOptions = isHovering
        ? options
        : searchTerm.trim() === ''
            ? options
            : options.filter(opt =>
                opt.label.toLowerCase().includes(searchTerm.toLowerCase())
            );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        setHighlightedIndex(-1);
        setIsHovering(false);
    };

    const handleKeyDown = (e) => {
        if (!isOpen) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(true);
                setHighlightedIndex(0);
                setIsHovering(false);
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev =>
                    prev < filteredOptions.length - 1 ? prev + 1 : prev
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
                    handleSelect(filteredOptions[highlightedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            case 'Tab':
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            default:
                break;
        }
    };

    const handleMouseEnter = () => {
        if (disabled) return;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        hoverTimeoutRef.current = setTimeout(() => {
            setIsHovering(true);
            setIsOpen(true);
            setHighlightedIndex(0);
        }, 200);
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        setTimeout(() => {
            if (!isOpen) {
                setIsHovering(false);
            }
        }, 300);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (highlightedIndex >= 0 && menuRef.current) {
            const items = menuRef.current.querySelectorAll('.ozlistui-custom-dropdown-option');
            if (items[highlightedIndex]) {
                items[highlightedIndex].scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex]);

    const handleInputClick = () => {
        if (disabled) return;
        setIsHovering(false);
        setSearchTerm(displayValue);
        setIsOpen(true);
        setHighlightedIndex(0);
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setIsHovering(false);
        setSearchTerm(newValue);
        setIsOpen(true);
        setHighlightedIndex(0);
        if (!options.find(opt => opt.label.toLowerCase() === newValue.toLowerCase())) {
            onChange('');
        }
    };

    return (
        <div
            className="ozlistui-custom-dropdown-wrapper"
            ref={wrapperRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="ozlistui-custom-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    onFocus={() => {
                        if (!disabled) {
                            setIsHovering(false);
                            setSearchTerm(displayValue);
                            setIsOpen(true);
                            setHighlightedIndex(0);
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu" ref={menuRef}>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt, index) => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''} ${highlightedIndex === index ? 'ozlistui-highlighted' : ''}`}
                                onClick={() => handleSelect(opt)}
                                onMouseEnter={() => setHighlightedIndex(index)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Helper function to parse packaging info
const parsePackagingInfo = (product) => {
    if (product.packaging_info) {
        try {
            if (typeof product.packaging_info === 'string') {
                return JSON.parse(product.packaging_info);
            }
            return product.packaging_info;
        } catch (e) {
            return null;
        }
    }
    return null;
};

// Group spelling variants next to one another without changing the stored name.
const normalizeProductName = (value = '') => String(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const getProductNameFamilyKey = (value = '') => normalizeProductName(value)
    .split(/\s+/)
    .filter(Boolean)
    .map(word => {
        const compactWord = word.replace(/(.)\1+/g, '$1');
        const skeleton = compactWord
            .replace(/[aeiouy]/g, '')
            .replace(/[ckq]+/g, 'k')
            .replace(/[sz]+/g, 's')
            .replace(/[dt]+/g, 't')
            .replace(/(.)\1+/g, '$1');
        return `${compactWord.slice(0, 2)}:${skeleton}`;
    })
    .join(' ');

const compareProductNameFamilies = (a, b) => {
    const aName = normalizeProductName(a.product_name);
    const bName = normalizeProductName(b.product_name);
    return getProductNameFamilyKey(aName).localeCompare(getProductNameFamilyKey(bName), undefined, { numeric: true })
        || aName.localeCompare(bName, undefined, { sensitivity: 'base', numeric: true })
        || String(a.batch_no || '').localeCompare(String(b.batch_no || ''), undefined, { sensitivity: 'base', numeric: true })
        || Number(a.id || 0) - Number(b.id || 0);
};

// Color options for filter
const colorOptions = [
    { value: '', label: 'All Colors' },
    { value: 'red', label: 'Red' },
    { value: 'blue', label: 'Blue' },
    { value: 'green', label: 'Green' },
    { value: 'yellow', label: 'Yellow' },
    { value: 'orange', label: 'Orange' },
    { value: 'purple', label: 'Purple' },
    { value: 'pink', label: 'Pink' },
    { value: 'brown', label: 'Brown' },
    { value: 'black', label: 'Black' },
    { value: 'white', label: 'White' },
    { value: 'gray', label: 'Gray' },
    { value: 'silver', label: 'Silver' },
    { value: 'gold', label: 'Gold' },
    { value: 'beige', label: 'Beige' },
    { value: 'cream', label: 'Cream' },
    { value: 'maroon', label: 'Maroon' },
    { value: 'navy', label: 'Navy Blue' },
    { value: 'teal', label: 'Teal' },
    { value: 'turquoise', label: 'Turquoise' },
    { value: 'lime', label: 'Lime' },
    { value: 'olive', label: 'Olive' },
    { value: 'coral', label: 'Coral' },
    { value: 'salmon', label: 'Salmon' },
    { value: 'lavender', label: 'Lavender' },
    { value: 'violet', label: 'Violet' },
    { value: 'magenta', label: 'Magenta' },
    { value: 'cyan', label: 'Cyan' },
    { value: 'indigo', label: 'Indigo' },
    { value: 'amber', label: 'Amber' },
    { value: 'peach', label: 'Peach' },
    { value: 'mint', label: 'Mint' },
    { value: 'sage', label: 'Sage' },
    { value: 'tan', label: 'Tan' },
    { value: 'ivory', label: 'Ivory' },
    { value: 'charcoal', label: 'Charcoal' },
    { value: 'slate', label: 'Slate' },
    { value: 'champagne', label: 'Champagne' },
    { value: 'rose', label: 'Rose' },
    { value: 'crimson', label: 'Crimson' },
    { value: 'burgundy', label: 'Burgundy' },
    { value: 'plum', label: 'Plum' },
    { value: 'mauve', label: 'Mauve' },
    { value: 'fawn', label: 'Fawn' },
    { value: 'mustard', label: 'Mustard' },
    { value: 'rust', label: 'Rust' },
    { value: 'terracotta', label: 'Terracotta' },
    { value: 'copper', label: 'Copper' },
    { value: 'bronze', label: 'Bronze' },
    { value: 'metallic', label: 'Metallic' },
    { value: 'multi', label: 'Multi-Color' },
    { value: 'transparent', label: 'Transparent' },
    { value: 'other', label: 'Other' }
];

// Size options for filter
const sizeOptions = [
    { value: '', label: 'All Sizes' },
    { value: 's', label: 'S' },
    { value: 'm', label: 'M' },
    { value: 'l', label: 'L' },
    { value: 'xl', label: 'XL' },
    { value: 'xxl', label: 'XXL' },
    { value: 'xxxl', label: 'XXXL' },
    { value: '4xl', label: '4XL' },
    { value: '5xl', label: '5XL' },
    { value: '6xl', label: '6XL' },
    { value: '7xl', label: '7XL' },
    { value: '8xl', label: '8XL' },
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '1_cm', label: '1 cm' },
    { value: '2_cm', label: '2 cm' },
    { value: '3_cm', label: '3 cm' },
    { value: '4_cm', label: '4 cm' },
    { value: '5_cm', label: '5 cm' },
    { value: '6_cm', label: '6 cm' },
    { value: '7_cm', label: '7 cm' },
    { value: '8_cm', label: '8 cm' },
    { value: '9_cm', label: '9 cm' },
    { value: '10_cm', label: '10 cm' },
    { value: '11_cm', label: '11 cm' },
    { value: '12_cm', label: '12 cm' },
    { value: '13_cm', label: '13 cm' },
    { value: '14_cm', label: '14 cm' },
    { value: '15_cm', label: '15 cm' },
    { value: '16_cm', label: '16 cm' },
    { value: '17_cm', label: '17 cm' },
    { value: '18_cm', label: '18 cm' },
    { value: '19_cm', label: '19 cm' },
    { value: '20_cm', label: '20 cm' },
    { value: '22_cm', label: '22 cm' },
    { value: '24_cm', label: '24 cm' },
    { value: '25_cm', label: '25 cm' },
    { value: '26_cm', label: '26 cm' },
    { value: '28_cm', label: '28 cm' },
    { value: '30_cm', label: '30 cm' },
    { value: '32_cm', label: '32 cm' },
    { value: '35_cm', label: '35 cm' },
    { value: '40_cm', label: '40 cm' },
    { value: '45_cm', label: '45 cm' },
    { value: '50_cm', label: '50 cm' },
    { value: '55_cm', label: '55 cm' },
    { value: '60_cm', label: '60 cm' },
    { value: '65_cm', label: '65 cm' },
    { value: '70_cm', label: '70 cm' },
    { value: '75_cm', label: '75 cm' },
    { value: '80_cm', label: '80 cm' },
    { value: '85_cm', label: '85 cm' },
    { value: '90_cm', label: '90 cm' },
    { value: '95_cm', label: '95 cm' },
    { value: '100_cm', label: '100 cm' },
    { value: '1_ft', label: '1 ft' },
    { value: '2_ft', label: '2 ft' },
    { value: '3_ft', label: '3 ft' },
    { value: '4_ft', label: '4 ft' },
    { value: '5_ft', label: '5 ft' },
    { value: '6_ft', label: '6 ft' },
    { value: '7_ft', label: '7 ft' },
    { value: '8_ft', label: '8 ft' },
    { value: '9_ft', label: '9 ft' },
    { value: '10_ft', label: '10 ft' },
    { value: '11_ft', label: '11 ft' },
    { value: '12_ft', label: '12 ft' },
    { value: '13_ft', label: '13 ft' },
    { value: '14_ft', label: '14 ft' },
    { value: '15_ft', label: '15 ft' },
    { value: '16_ft', label: '16 ft' },
    { value: '17_ft', label: '17 ft' },
    { value: '18_ft', label: '18 ft' },
    { value: '19_ft', label: '19 ft' },
    { value: '20_ft', label: '20 ft' },
    { value: '0.5_m', label: '0.5 m' },
    { value: '1_m', label: '1 m' },
    { value: '1.5_m', label: '1.5 m' },
    { value: '2_m', label: '2 m' },
    { value: '2.5_m', label: '2.5 m' },
    { value: '3_m', label: '3 m' },
    { value: '4_m', label: '4 m' },
    { value: '5_m', label: '5 m' },
    { value: '6_m', label: '6 m' },
    { value: '7_m', label: '7 m' },
    { value: '8_m', label: '8 m' },
    { value: '9_m', label: '9 m' },
    { value: '10_m', label: '10 m' },
    { value: '12_m', label: '12 m' },
    { value: '15_m', label: '15 m' },
    { value: '20_m', label: '20 m' },
    { value: '25_m', label: '25 m' },
    { value: '30_m', label: '30 m' },
    { value: '40_m', label: '40 m' },
    { value: '50_m', label: '50 m' },
    { value: '60_m', label: '60 m' },
    { value: '70_m', label: '70 m' },
    { value: '80_m', label: '80 m' },
    { value: '90_m', label: '90 m' },
    { value: '100_m', label: '100 m' },
    { value: 'one_size', label: 'One Size' },
    { value: 'free_size', label: 'Free Size' },
    { value: 'adjustable', label: 'Adjustable' },
    { value: 'custom', label: 'Custom' },
    { value: 'other', label: 'Other' }
];

// Helper function to generate batch number - copied from cosmetics_products.js
const generateBulkBatchNo = (productName, shopId, rowIndex) => {
    const cleaned = (productName || 'XXX').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const prefix = (cleaned || 'XXX').substring(0, 3).padEnd(3, 'X');
    const shopPart = String(shopId || '0').replace(/\D/g, '').slice(-3).padStart(3, '0');
    const timePart = Date.now().toString(36).toUpperCase();
    const rowPart = String(rowIndex + 1).padStart(3, '0');
    const randomPart = Math.random().toString(36).slice(2, 7).toUpperCase().padEnd(5, 'X');
    return `${prefix}-${shopPart}-${timePart}-${rowPart}-${randomPart}`;
};

// Main Component
const CosmeticsProductsList = () => {
    const unitOptions = [
        { value: '', label: 'Select Unit' },
        { value: 'Units', label: 'Units' },
        { value: 'Yard', label: 'Yard' },
        { value: 'Feet', label: 'Feet' },
        { value: 'Set', label: 'Set' },
        { value: 'Dozen', label: 'Dozen' },
        { value: 'Box', label: 'Box' }
    ];

    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [selectedProductIds, setSelectedProductIds] = useState([]);
    const [showBulkEditModal, setShowBulkEditModal] = useState(false);
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [bulkEditRows, setBulkEditRows] = useState([]);
    const [bulkEditErrors, setBulkEditErrors] = useState({});
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // Edit mode state - always 'bulk' now
    const [editMode] = useState('bulk');

    // Bulk common fields for group edit mode
    const [bulkCommonFields, setBulkCommonFields] = useState({
        product_name: '',
        rq: '',
        category: '',
        company: '',
        supplier_name: '',
        cost_price_per_pack: '',
        profit_percent: '',
        sell_price_per_unit: ''
    });
    const [bulkCommonErrors, setBulkCommonErrors] = useState({});

    // PDF Options State
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 650, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 950, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state for single mode (kept for backward compatibility but no longer used directly)
    const [editFormData, setEditFormData] = useState({
        date: '',
        product_name: '',
        warranty: '',
        batch_no: '',
        barcode: '',
        company: '',
        supplier_name: '',
        supplier_id: '',
        gunit: '',
        cost_price_per_pack: '',
        sell_price_per_unit: '',
        total_quantity: '',
        quantity_alert: '1',
        expiry_date: '',
        cost_per_unit: '',
        sell_per_pack: '',
        packing_type: 'packet',
        sub_packing_type: 'piece',
        items_per_pack: '1',
        unit_of_measure: 'piece',
        category: '',
        color: '',
        size: ''
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    // Business info state
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        businessaddress: '',
        fullname: '',
        email: ''
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);

    // Filter states
    const [filterBy, setFilterBy] = useState('');
    const [productNameFilter, setProductNameFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [colorFilter, setColorFilter] = useState('');
    const [sizeFilter, setSizeFilter] = useState('');
    const [batchFilter, setBatchFilter] = useState('');
    const [barcodeFilter, setBarcodeFilter] = useState('');
    const [addedByFilter, setAddedByFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [stockStatusFilter, setStockStatusFilter] = useState('');

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const filterByOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'productName', label: translations.productNameFilter || 'Product Name' },
        { value: 'category', label: translations.categoryFilter || 'Category' },
        { value: 'company', label: translations.companyFilter || 'Company Name' },
        { value: 'color', label: translations.colorFilter || 'Color' },
        { value: 'size', label: translations.sizeFilter || 'Size' },
        { value: 'batch', label: translations.batchFilter || 'Batch Number' },
        { value: 'barcode', label: translations.barcodeFilter || 'Barcode' },
        { value: 'added_by', label: translations.addedByFilter || 'Added By' }
    ], [translations]);

    const stockStatusOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'inStock', label: translations.inStock || 'In Stock' },
        { value: 'lowStock', label: translations.lowStock || 'Low Stock' },
        { value: 'outOfStock', label: translations.outOfStock || 'Out of Stock' }
    ], [translations]);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // THEME SYNC
    // ============================================
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
            setCurrentTheme(color);
        };

        applyTheme(currentTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentTheme) {
                applyTheme(storedTheme);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [currentTheme]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);

            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozlistui-dark');
                } else {
                    container.classList.remove('ozlistui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozlistui-dark');
                document.documentElement.classList.add('ozlistui-dark');
            } else {
                document.body.classList.remove('ozlistui-dark');
                document.documentElement.classList.remove('ozlistui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await productListTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Center modal function
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showEditModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showEditModal]);

    // Fetch products
    const fetchProducts = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }
        if (isMountedRef.current) setLoading(true);
        try {
            const response = await fetch(PRODUCTS_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records',
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setProducts(data.data || []);
                    resetFilters();
                } else {
                    showToast('error', data.message || translations.networkError || 'Network error occurred');
                }
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            if (isMountedRef.current) showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        businessaddress: data.businessaddress || '',
                        fullname: data.fullname || '',
                        email: data.email || ''
                    });
                } else {
                    setBusinessInfo({
                        businessname: user.business_name || '',
                        bussinesslogo: '',
                        businessaddress: '',
                        fullname: user.fullname || '',
                        email: user.email || ''
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || '',
                    bussinesslogo: '',
                    businessaddress: '',
                    fullname: user.fullname || '',
                    email: user.email || ''
                });
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchProducts();
            fetchBusinessInfo();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                resetFilters();
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast]);

    const applyFilters = useCallback(() => {
        let filtered = [...products];

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(product =>
                product.product_name?.toLowerCase().includes(term) ||
                product.warranty?.toLowerCase().includes(term) ||
                product.batch_no?.toLowerCase().includes(term) ||
                product.barcode?.toLowerCase().includes(term) ||
                product.company?.toLowerCase().includes(term) ||
                product.supplier_name?.toLowerCase().includes(term) ||
                product.category?.toLowerCase().includes(term) ||
                product.gunit?.toLowerCase().includes(term) ||
                product.color?.toLowerCase().includes(term) ||
                product.size?.toLowerCase().includes(term) ||
                product.added_by_username?.toLowerCase().includes(term) ||
                product.username?.toLowerCase().includes(term)
            );
        }

        if (stockStatusFilter) {
            filtered = filtered.filter(product => {
                const quantity = parseFloat(product.quantity) || 0;
                const alert = parseFloat(product.quantity_alert) || 0;
                if (stockStatusFilter === 'inStock') return quantity > alert;
                if (stockStatusFilter === 'lowStock') return quantity <= alert && quantity > 0;
                if (stockStatusFilter === 'outOfStock') return quantity <= 0;
                return true;
            });
        }

        if (filterBy === 'productName' && productNameFilter.trim()) {
            const term = productNameFilter.toLowerCase();
            filtered = filtered.filter(product => product.product_name?.toLowerCase().includes(term));
        }
        if (filterBy === 'category' && categoryFilter.trim()) {
            filtered = filtered.filter(product => product.category?.toLowerCase() === categoryFilter.toLowerCase());
        }
        if (filterBy === 'company' && companyFilter.trim()) {
            const term = companyFilter.toLowerCase();
            filtered = filtered.filter(product => product.company?.toLowerCase().includes(term));
        }
        if (filterBy === 'color' && colorFilter.trim()) {
            filtered = filtered.filter(product => product.color?.toLowerCase() === colorFilter.toLowerCase());
        }
        if (filterBy === 'size' && sizeFilter.trim()) {
            filtered = filtered.filter(product => product.size?.toLowerCase() === sizeFilter.toLowerCase());
        }
        if (filterBy === 'batch' && batchFilter.trim()) {
            const term = batchFilter.toLowerCase();
            filtered = filtered.filter(product => product.batch_no?.toLowerCase().includes(term));
        }
        if (filterBy === 'barcode' && barcodeFilter.trim()) {
            const term = barcodeFilter.toLowerCase();
            filtered = filtered.filter(product => product.barcode?.toLowerCase().includes(term));
        }
        if (filterBy === 'added_by' && addedByFilter.trim()) {
            const term = addedByFilter.toLowerCase();
            filtered = filtered.filter(product =>
                (product.added_by_username?.toLowerCase().includes(term)) ||
                (product.username?.toLowerCase().includes(term))
            );
        }

        if (startDate) {
            const start = new Date(startDate);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                return productDate >= start;
            });
        }
        if (endDate) {
            const end = new Date(endDate);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                end.setHours(23, 59, 59, 999);
                return productDate <= end;
            });
        }

        filtered.sort(compareProductNameFamilies);

        setFilteredProducts(filtered);
        setCurrentPage(1);
    }, [products, searchTerm, stockStatusFilter, filterBy, productNameFilter, categoryFilter, companyFilter, colorFilter, sizeFilter, batchFilter, barcodeFilter, addedByFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    const resetFilters = useCallback(() => {
        setFilterBy('');
        setProductNameFilter('');
        setCategoryFilter('');
        setCompanyFilter('');
        setColorFilter('');
        setSizeFilter('');
        setBatchFilter('');
        setBarcodeFilter('');
        setAddedByFilter('');
        setStartDate('');
        setEndDate('');
        setStockStatusFilter('');
        setSearchTerm('');
    }, []);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    }, []);

    const formatDateGlobal = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    };

    const currentDateGlobal = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getRowsPerPage = useCallback(() => {
        if (pdfOrientation === 'landscape') {
            return 18;
        }
        return 12;
    }, [pdfOrientation]);

    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentProducts = filteredProducts.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentProducts };
    }, [filteredProducts, currentPage, itemsPerPage]);

    const canManageProduct = useCallback((product) => {
        if (!product || !user?.username || !currentShop?.shop_id) return false;
        const addedBy = product.added_by_username || product.username || '';
        return addedBy === user.username
            && Number(product.shop_id) === Number(currentShop.shop_id);
    }, [user?.username, currentShop?.shop_id]);

    const selectedProductIdSet = useMemo(
        () => new Set(selectedProductIds.map(Number)),
        [selectedProductIds]
    );

    const selectedProducts = useMemo(() => {
        const selected = products.filter(product => selectedProductIdSet.has(Number(product.id)) && canManageProduct(product));
        return selected.sort(compareProductNameFamilies);
    }, [products, selectedProductIdSet, canManageProduct]);

    const manageableProductsOnPage = useMemo(
        () => pagination.currentProducts.filter(canManageProduct),
        [pagination.currentProducts, canManageProduct]
    );

    const allManageableOnPageSelected = manageableProductsOnPage.length > 0
        && manageableProductsOnPage.every(product => selectedProductIdSet.has(Number(product.id)));

    useEffect(() => {
        setSelectedProductIds(previous => previous.filter(id => {
            const product = products.find(candidate => Number(candidate.id) === Number(id));
            return product && canManageProduct(product);
        }));
    }, [products, canManageProduct]);

    const toggleProductSelection = useCallback((product) => {
        if (!canManageProduct(product)) return;
        const productId = Number(product.id);
        setSelectedProductIds(previous => previous.includes(productId)
            ? previous.filter(id => id !== productId)
            : [...previous, productId]);
    }, [canManageProduct]);

    const toggleCurrentPageSelection = useCallback(() => {
        const pageIds = manageableProductsOnPage.map(product => Number(product.id));
        setSelectedProductIds(previous => {
            const selected = new Set(previous.map(Number));
            const shouldClearPage = pageIds.length > 0 && pageIds.every(id => selected.has(id));
            pageIds.forEach(id => shouldClearPage ? selected.delete(id) : selected.add(id));
            return Array.from(selected);
        });
    }, [manageableProductsOnPage]);

    const clearProductSelection = useCallback(() => {
        setSelectedProductIds([]);
    }, []);

    const getStockValueForProduct = useCallback((product) => {
        const costPerUnit = parseFloat(
            product.cost_per_unit ||
            product.costPerUnit ||
            product.unit_cost ||
            (product.cost_per_pack / (product.items_per_pack || 1)) ||
            0
        );
        const quantity = parseFloat(product.quantity || 0);
        return costPerUnit * quantity;
    }, []);

    const totalStockValue = filteredProducts
        .filter(product => {
            const quantity = parseFloat(product.quantity || 0);
            return quantity > 0;
        })
        .reduce((sum, product) => {
            return sum + getStockValueForProduct(product);
        }, 0);

    // ============================================
    // PDF EXPORT FUNCTION
    // ============================================
    const exportToPDF = useCallback(() => {
        if (!filteredProducts?.length) {
            showToast('warning', translations.noDataToExport || 'No data to export');
            return;
        }

        setPdfLoading(true);
        try {
            const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
            const t = (key, fallback) => translations[key] || fallback;
            const pageFormat = { a4: 'a4', letter: 'letter', legal: 'legal', a5: 'a5' }[pdfPageSize] || 'a4';
            const doc = new jsPDF({
                orientation: pdfOrientation,
                unit: 'mm',
                format: pageFormat,
                compress: true
            });

            const themeRgb = (() => {
                const hex = String(currentTheme || '#2563eb').replace('#', '');
                const normalized = hex.length === 3
                    ? hex.split('').map(char => char + char).join('')
                    : hex.padEnd(6, '0').slice(0, 6);
                return [0, 2, 4].map(index => parseInt(normalized.slice(index, index + 2), 16) || 0);
            })();
            const margin = 12;
            const rowsPerRangePage = getRowsPerPage();
            let productsToExport = [...filteredProducts];

            if (pdfPageRange === 'range') {
                const availablePages = Math.ceil(productsToExport.length / rowsPerRangePage);
                const firstPage = Math.min(Math.max(1, Number(pdfStartPage) || 1), availablePages);
                const lastPage = Math.min(
                    Math.max(firstPage, Number(pdfEndPage) || firstPage),
                    availablePages
                );
                productsToExport = productsToExport.slice(
                    (firstPage - 1) * rowsPerRangePage,
                    lastPage * rowsPerRangePage
                );
            }

            const generatedAt = new Date();
            const reportId = `${currentDateGlobal().replace(/-/g, '')}-${String(generatedAt.getTime()).slice(-6)}`;
            const pageWidth = doc.internal.pageSize.getWidth();
            const number = value => Number.parseFloat(value) || 0;
            const money = value => `Rs. ${number(value).toFixed(2)}`;
            const getCostPerUnit = product => number(
                product.cost_per_unit ||
                product.costPerUnit ||
                product.unit_cost ||
                (number(product.cost_per_pack) / (number(product.items_per_pack) || 1))
            );
            const getStockStatus = product => {
                const quantity = number(product.quantity);
                const alert = number(product.quantity_alert);
                if (quantity <= 0) return t('outOfStock', 'Out of Stock');
                if (quantity <= alert) return t('lowStock', 'Low Stock');
                return t('inStock', 'In Stock');
            };

            const tableColumns = [
                t('serialNo', 'S.No'),
                t('productName', 'Product Name'),
                t('warranty', 'Warranty'),
                t('batchNumber', 'Batch Number'),
                t('barcode', 'Barcode'),
                t('company', 'Company'),
                t('supplierName', 'Supplier'),
                t('costPerUnit', 'Cost/Unit'),
                t('sellPerUnit', 'Price/Unit'),
                t('sellPerPack', 'Price/Pack'),
                t('totalQuantity', 'Quantity'),
                t('expiryDate', 'Expiry'),
                t('stockStatus', 'Status'),
                t('stockValue', 'Stock Value'),
                t('addedBy', 'Added By')
            ];
            const tableRows = productsToExport.map((product, index) => {
                const quantity = number(product.quantity);
                const costPerUnit = getCostPerUnit(product);
                return [
                    index + 1,
                    product.product_name || '-',
                    product.warranty || '-',
                    product.batch_no || '-',
                    product.barcode || '-',
                    product.company || '-',
                    product.supplier_name || '-',
                    money(costPerUnit),
                    money(product.sell_price_per_unit),
                    money(product.sell_per_pack),
                    quantity.toFixed(2),
                    product.expiry_date ? formatDateGlobal(product.expiry_date) : '-',
                    getStockStatus(product),
                    money(costPerUnit * quantity),
                    product.added_by_username || product.username || '-'
                ];
            });

            const activeFilters = [
                searchTerm && `${t('search', 'Search')}: "${searchTerm}"`,
                categoryFilter && `${t('category', 'Category')}: ${categoryFilter}`,
                companyFilter && `${t('company', 'Company')}: ${companyFilter}`,
                colorFilter && `${t('color', 'Color')}: ${colorFilter}`,
                sizeFilter && `${t('size', 'Size')}: ${sizeFilter}`,
                startDate && `${t('from', 'From')}: ${startDate}`,
                endDate && `${t('to', 'To')}: ${endDate}`
            ].filter(Boolean).join('  |  ');
            const drawReportHeader = () => {
                doc.setTextColor(107, 114, 128);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(7);
                doc.text(t('productReport', 'PRODUCT REPORT').toUpperCase(), pageWidth / 2, 11, { align: 'center' });

                doc.setTextColor(31, 41, 55);
                doc.setFontSize(17);
                doc.text(currentShop?.shop_name || t('inventoryReport', 'Inventory Report'), pageWidth / 2, 19, { align: 'center' });

                doc.setDrawColor(...themeRgb);
                doc.setLineWidth(0.8);
                doc.line(pageWidth / 2 - 10, 23, pageWidth / 2 + 10, 23);

                let detailY = 28;
                if (businessInfo.businessname) {
                    doc.setTextColor(107, 114, 128);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8);
                    doc.text(businessInfo.businessname, pageWidth / 2, detailY, { align: 'center' });
                    detailY += 4;
                }

                doc.setFontSize(7);
                doc.text(
                    `${t('totalProducts', 'Total Products')}: ${productsToExport.length}  |  ${t('generated', 'Generated')}: ${generatedAt.toLocaleString(currentLanguage)}`,
                    pageWidth / 2,
                    detailY,
                    { align: 'center' }
                );

                const metaY = detailY + 6;
                doc.setDrawColor(229, 231, 235);
                doc.setLineWidth(0.2);
                doc.line(margin, metaY - 3, pageWidth - margin, metaY - 3);
                doc.line(margin, metaY + 2, pageWidth - margin, metaY + 2);
                doc.setFontSize(6.5);
                doc.text(`${t('reportId', 'Report ID')}: #${reportId}`, margin, metaY);
                doc.text(
                    `${t('generatedBy', 'Generated by')}: ${user?.fullname || user?.username || 'System'}`,
                    pageWidth / 2,
                    metaY,
                    { align: 'center' }
                );
                doc.text(
                    `${t('shopCode', 'Shop Code')}: ${currentShop?.shop_code || 'N/A'}`,
                    pageWidth - margin,
                    metaY,
                    { align: 'right' }
                );

                if (activeFilters) {
                    doc.setFillColor(249, 250, 251);
                    doc.setDrawColor(...themeRgb);
                    doc.setLineWidth(0.8);
                    doc.rect(margin, metaY + 5, pageWidth - margin * 2, 7, 'F');
                    doc.line(isRTL ? pageWidth - margin : margin, metaY + 5, isRTL ? pageWidth - margin : margin, metaY + 12);
                    doc.setTextColor(75, 85, 99);
                    doc.setFontSize(6.5);
                    doc.text(`${t('filtersApplied', 'FILTERS APPLIED')}: ${activeFilters}`, margin + 3, metaY + 9.5, {
                        maxWidth: pageWidth - margin * 2 - 6,
                        align: isRTL ? 'right' : 'left'
                    });
                }
            };

            autoTable(doc, {
                head: [tableColumns],
                body: tableRows,
                startY: activeFilters ? 49 : 42,
                margin: { top: activeFilters ? 49 : 42, right: margin, bottom: 14, left: margin },
                theme: 'grid',
                showHead: 'everyPage',
                horizontalPageBreak: pageWidth < 250,
                horizontalPageBreakRepeat: [0, 1],
                horizontalPageBreakBehaviour: 'immediately',
                styles: {
                    font: 'helvetica',
                    fontSize: pdfOrientation === 'landscape' ? 5.3 : 4.6,
                    cellPadding: 1.1,
                    lineColor: [229, 231, 235],
                    lineWidth: 0.15,
                    textColor: [31, 41, 55],
                    overflow: 'linebreak',
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: themeRgb,
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                    lineColor: themeRgb,
                    minCellHeight: 7
                },
                alternateRowStyles: { fillColor: [249, 250, 251] },
                columnStyles: {
                    0: { cellWidth: 7, halign: 'center' },
                    1: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left', fontStyle: 'bold' },
                    2: { cellWidth: 14, halign: 'center' },
                    3: { cellWidth: 17, halign: 'center' },
                    4: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left' },
                    5: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left' },
                    6: { cellWidth: 15, halign: 'right' },
                    7: { cellWidth: 15, halign: 'right' },
                    8: { cellWidth: 15, halign: 'right' },
                    9: { cellWidth: 12, halign: 'right' },
                    10: { cellWidth: 10, halign: 'right' },
                    11: { cellWidth: 16, halign: 'center' },
                    12: { cellWidth: 17, halign: 'center' },
                    13: { cellWidth: 17, halign: 'right' },
                    14: { cellWidth: 16, halign: 'center' }
                },
                didDrawPage: ({ pageNumber }) => {
                    drawReportHeader();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const pageCount = doc.internal.getNumberOfPages();
                    doc.setDrawColor(229, 231, 235);
                    doc.setLineWidth(0.2);
                    doc.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
                    doc.setTextColor(107, 114, 128);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(7);
                    doc.text(
                        `${t('page', 'Page')} ${pageNumber} ${t('of', 'of')} ${pageCount}`,
                        pageWidth / 2,
                        pageHeight - 6,
                        { align: 'center' }
                    );
                }
            });

            const finalPageCount = doc.internal.getNumberOfPages();
            for (let page = 1; page <= finalPageCount; page += 1) {
                doc.setPage(page);
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.setFillColor(255, 255, 255);
                doc.rect(0, pageHeight - 11, pageWidth, 11, 'F');
                doc.setDrawColor(229, 231, 235);
                doc.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
                doc.setTextColor(107, 114, 128);
                doc.setFontSize(7);
                doc.text(`${t('page', 'Page')} ${page} ${t('of', 'of')} ${finalPageCount}`, pageWidth / 2, pageHeight - 6, { align: 'center' });
            }

            const safeShopName = (currentShop?.shop_name || 'Export').replace(/[^a-z0-9_-]/gi, '_');
            doc.save(`Product_Report_${safeShopName}_${currentDateGlobal()}.pdf`);
            showToast(
                'success',
                `${t('reportGenerated', 'Report generated!')} ${productsToExport.length} ${t('products', 'products')} ${t('on', 'on')} ${finalPageCount} ${t('pages', 'page(s)')}`
            );
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', translations.pdfGenerationError || 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [filteredProducts, currentLanguage, pdfOrientation, pdfPageSize, pdfPageRange, pdfStartPage, pdfEndPage, translations, businessInfo, currentShop, user, showToast, getRowsPerPage, searchTerm, categoryFilter, companyFilter, colorFilter, sizeFilter, startDate, endDate, currentTheme]);

    const handleView = useCallback((product) => { setSelectedProduct(product); setShowViewModal(true); }, []);

    // ============================================
    // OPEN BULK EDITOR - ALWAYS USES BULK MODE
    // ============================================
    const openBulkEditor = useCallback((product) => {
        // If a single product is passed, use it; otherwise use selectedProducts
        const productsToEdit = product ? [product] : selectedProducts;
        
        if (productsToEdit.length === 0) {
            showToast('warning', 'Select at least one product first');
            return;
        }

        const firstProduct = productsToEdit[0];
        
        // Set common fields from the first selected product
        setBulkCommonFields({
            product_name: firstProduct.product_name || '',
            rq: String(productsToEdit.length),
            category: firstProduct.category || '',
            company: firstProduct.company || '',
            supplier_name: firstProduct.supplier_name || '',
            cost_price_per_pack: firstProduct.cost_per_pack || firstProduct.cost_price || '',
            profit_percent: firstProduct.profit_percent || '',
            sell_price_per_unit: firstProduct.sell_price_per_unit || firstProduct.sell_price || ''
        });
        setBulkCommonErrors({});

        // Create rows for each selected product
        const rows = productsToEdit.map(product => ({
            id: Number(product.id),
            _is_existing: true, // Mark as existing product
            date: product.date ? String(product.date).split('T')[0] : '',
            product_name: product.product_name || '',
            warranty: product.warranty || '',
            batch_no: product.batch_no || '',
            barcode: product.barcode || '',
            _original_batch_no: product.batch_no || '',
            _original_barcode: product.barcode || '',
            category: product.category || '',
            company: product.company || '',
            supplier_name: product.supplier_name || '',
            supplier_id: product.supplier_id || null,
            _original_supplier_name: product.supplier_name || '',
            _original_supplier_id: product.supplier_id || null,
            color: product.color || '',
            size: product.size || '',
            gunit: product.gunit || '',
            cost_price_per_pack: product.cost_per_pack ?? product.cost_price ?? '0',
            sell_price_per_unit: product.sell_price_per_unit ?? product.sell_price ?? '0',
            profit_percent: product.profit_percent ?? '',
            total_quantity: product.quantity ?? '0',
            quantity_alert: product.quantity_alert ?? '0',
            expiry_date: product.expiry_date ? String(product.expiry_date).split('T')[0] : '',
            packing_type: product.packing_type || 'packet',
            sub_packing_type: product.sub_packing_type || 'piece',
            items_per_pack: product.items_per_pack || '1',
            unit_of_measure: product.unit_of_measure || 'piece'
        }));

        setBulkEditRows(rows);
        setBulkEditErrors({});
        setShowBulkEditModal(true);
        
        // Focus the RQ field after modal opens
        setTimeout(() => {
            const rqInput = document.getElementById('bulk_common_rq');
            if (rqInput) rqInput.focus();
        }, 300);
    }, [selectedProducts, showToast]);

    // ============================================
    // HANDLE RQ CHANGE - Add/Remove rows based on RQ
    // ============================================
    const handleRQChange = useCallback((value) => {
        const rq = parseInt(value) || 1;
        setBulkCommonFields(prev => ({ ...prev, rq: String(rq) }));

        setBulkEditRows(prevRows => {
            const existingCount = prevRows.length;
            const firstProduct = prevRows[0] || {};
            
            if (rq > existingCount) {
                // Add new rows
                const newRows = [];
                for (let i = existingCount; i < rq; i++) {
                    const newBatchNo = generateBulkBatchNo(
                        firstProduct.product_name || 'XXX',
                        currentShop?.shop_id || 0,
                        i
                    );
                    newRows.push({
                        id: null, // New product - no ID
                        _is_existing: false,
                        date: firstProduct.date || new Date().toISOString().split('T')[0],
                        product_name: firstProduct.product_name || '',
                        warranty: firstProduct.warranty || '',
                        batch_no: newBatchNo,
                        barcode: '',
                        _original_batch_no: newBatchNo,
                        _original_barcode: '',
                        category: firstProduct.category || '',
                        company: firstProduct.company || '',
                        supplier_name: firstProduct.supplier_name || '',
                        supplier_id: firstProduct.supplier_id || null,
                        _original_supplier_name: firstProduct.supplier_name || '',
                        _original_supplier_id: firstProduct.supplier_id || null,
                        color: firstProduct.color || '',
                        size: firstProduct.size || '',
                        gunit: firstProduct.gunit || '',
                        cost_price_per_pack: firstProduct.cost_price_per_pack || '0',
                        sell_price_per_unit: firstProduct.sell_price_per_unit || '0',
                        profit_percent: firstProduct.profit_percent || '',
                        total_quantity: firstProduct.total_quantity || '0',
                        quantity_alert: firstProduct.quantity_alert || '0',
                        expiry_date: firstProduct.expiry_date || '',
                        packing_type: firstProduct.packing_type || 'packet',
                        sub_packing_type: firstProduct.sub_packing_type || 'piece',
                        items_per_pack: firstProduct.items_per_pack || '1',
                        unit_of_measure: firstProduct.unit_of_measure || 'piece'
                    });
                }
                return [...prevRows, ...newRows];
            } else if (rq < existingCount && rq > 0) {
                // Remove rows (keep the first rq rows)
                return prevRows.slice(0, rq);
            }
            return prevRows;
        });

        // Clear errors for the affected rows
        setBulkEditErrors({});
    }, [currentShop?.shop_id]);

    // ============================================
    // APPLY COMMON FIELDS TO ALL ROWS
    // ============================================
    const applyCommonFieldsToRows = useCallback(() => {
        setBulkEditRows(prevRows => prevRows.map(row => ({
            ...row,
            product_name: bulkCommonFields.product_name || row.product_name,
            category: bulkCommonFields.category || row.category,
            company: bulkCommonFields.company || row.company,
            supplier_name: bulkCommonFields.supplier_name || row.supplier_name,
            cost_price_per_pack: bulkCommonFields.cost_price_per_pack || row.cost_price_per_pack,
            profit_percent: bulkCommonFields.profit_percent || row.profit_percent,
            sell_price_per_unit: bulkCommonFields.sell_price_per_unit || row.sell_price_per_unit
        })));
        showToast('success', 'Common fields applied to all products');
    }, [bulkCommonFields, showToast]);

    const updateBulkEditRow = useCallback((rowIndex, field, value) => {
        setBulkEditRows(previous => {
            const newRows = [...previous];
            const row = newRows[rowIndex];
            if (!row) return previous;
            
            if (field === 'sell_price_per_unit') {
                newRows[rowIndex] = { ...row, [field]: value, profit_percent: '' };
            } else if (field === 'supplier_name') {
                const supplierUnchanged = String(value).trim().toLowerCase()
                    === String(row._original_supplier_name || '').trim().toLowerCase();
                newRows[rowIndex] = {
                    ...row,
                    supplier_name: value,
                    supplier_id: supplierUnchanged ? row._original_supplier_id : null
                };
            } else {
                newRows[rowIndex] = { ...row, [field]: value };
            }
            return newRows;
        });
        
        // Clear error for this field
        setBulkEditErrors(prev => {
            const next = { ...prev };
            delete next[`${rowIndex}.${field}`];
            return next;
        });
    }, []);

    // ============================================
    // ADD NEW ROW (Manual)
    // ============================================
    const addNewRow = useCallback(() => {
        const firstProduct = bulkEditRows[0] || {};
        const newIndex = bulkEditRows.length;
        const newBatchNo = generateBulkBatchNo(
            firstProduct.product_name || 'XXX',
            currentShop?.shop_id || 0,
            newIndex
        );
        
        const newRow = {
            id: null,
            _is_existing: false,
            date: firstProduct.date || new Date().toISOString().split('T')[0],
            product_name: firstProduct.product_name || '',
            warranty: firstProduct.warranty || '',
            batch_no: newBatchNo,
            barcode: '',
            _original_batch_no: newBatchNo,
            _original_barcode: '',
            category: firstProduct.category || '',
            company: firstProduct.company || '',
            supplier_name: firstProduct.supplier_name || '',
            supplier_id: firstProduct.supplier_id || null,
            _original_supplier_name: firstProduct.supplier_name || '',
            _original_supplier_id: firstProduct.supplier_id || null,
            color: firstProduct.color || '',
            size: firstProduct.size || '',
            gunit: firstProduct.gunit || '',
            cost_price_per_pack: firstProduct.cost_price_per_pack || '0',
            sell_price_per_unit: firstProduct.sell_price_per_unit || '0',
            profit_percent: firstProduct.profit_percent || '',
            total_quantity: firstProduct.total_quantity || '0',
            quantity_alert: firstProduct.quantity_alert || '0',
            expiry_date: firstProduct.expiry_date || '',
            packing_type: firstProduct.packing_type || 'packet',
            sub_packing_type: firstProduct.sub_packing_type || 'piece',
            items_per_pack: firstProduct.items_per_pack || '1',
            unit_of_measure: firstProduct.unit_of_measure || 'piece'
        };
        
        setBulkEditRows(prev => [...prev, newRow]);
        setBulkCommonFields(prev => ({ ...prev, rq: String(bulkEditRows.length + 1) }));
        showToast('success', `New row ${bulkEditRows.length + 1} added`);
    }, [bulkEditRows, currentShop?.shop_id]);

    // ============================================
    // REMOVE ROW
    // ============================================
    const removeRow = useCallback((rowIndex) => {
        setBulkEditRows(prev => {
            const newRows = prev.filter((_, index) => index !== rowIndex);
            setBulkCommonFields(fields => ({ ...fields, rq: String(newRows.length) }));
            return newRows;
        });
        showToast('success', `Row ${rowIndex + 1} removed`);
    }, []);

    const validateBulkEditRows = useCallback(() => {
        const errors = {};
        const batchNumbers = new Map();
        const barcodes = new Map();

        bulkEditRows.forEach((row, index) => {
            const prefix = String(index);
            
            // Required fields
            if (!String(row.product_name || '').trim()) {
                errors[`${prefix}.product_name`] = 'Product name is required';
            }
            if (!String(row.batch_no || '').trim()) {
                errors[`${prefix}.batch_no`] = 'Batch number is required';
            }
            
            // For existing products, barcode is required; for new ones, it can be empty (user will fill later)
            if (row._is_existing && !String(row.barcode || '').trim()) {
                errors[`${prefix}.barcode`] = 'Barcode is required for existing product';
            }

            // Numeric validations
            [
                ['cost_price_per_pack', 'Cost must be zero or greater'],
                ['sell_price_per_unit', 'Selling price must be zero or greater'],
                ['total_quantity', 'Quantity must be zero or greater']
            ].forEach(([field, message]) => {
                const number = Number(row[field]);
                if (row[field] === '' || !Number.isFinite(number) || number < 0) {
                    errors[`${prefix}.${field}`] = message;
                }
            });

            if (row.profit_percent !== '') {
                const profit = Number(row.profit_percent);
                if (!Number.isFinite(profit) || profit < 0) {
                    errors[`${prefix}.profit_percent`] = 'Profit must be zero or greater';
                }
            }

            // Check for duplicate batch numbers and barcodes (only for existing products)
            const batchKey = String(row.batch_no || '').trim().toLowerCase();
            const barcodeKey = String(row.barcode || '').trim().toLowerCase();
            const batchChanged = batchKey !== String(row._original_batch_no || '').trim().toLowerCase();
            const barcodeChanged = barcodeKey !== String(row._original_barcode || '').trim().toLowerCase();
            
            if (batchKey) {
                if (batchNumbers.has(batchKey)) {
                    const existingIndex = batchNumbers.get(batchKey);
                    if (batchChanged || bulkEditRows[existingIndex].batch_no !== row._original_batch_no) {
                        errors[`${prefix}.batch_no`] = 'Duplicate batch number in selected rows';
                        errors[`${existingIndex}.batch_no`] = 'Duplicate batch number in selected rows';
                    }
                } else {
                    batchNumbers.set(batchKey, index);
                }
            }
            
            // Barcodes are shop-wide identities. Check every entered barcode,
            // including rows that were added in this modal, so we never send
            // two competing writes for the same product.
            if (barcodeKey) {
                if (barcodes.has(barcodeKey)) {
                    const existingIndex = barcodes.get(barcodeKey);
                    if (barcodeChanged || bulkEditRows[existingIndex].barcode !== row._original_barcode) {
                        errors[`${prefix}.barcode`] = 'Duplicate barcode in selected rows';
                        errors[`${existingIndex}.barcode`] = 'Duplicate barcode in selected rows';
                    }
                } else {
                    barcodes.set(barcodeKey, index);
                }
            }
        });

        setBulkEditErrors(errors);
        return Object.keys(errors).length === 0;
    }, [bulkEditRows]);

    // ============================================
    // HANDLE BULK EDIT SUBMIT
    // ============================================
    const handleBulkEditSubmit = useCallback(async (event) => {
        event.preventDefault();
        if (!currentShop || !user?.username || !validateBulkEditRows()) return;

        setBulkActionLoading(true);
        try {
            // A row created in this dialog can still represent an existing
            // product: the barcode is the durable shop-wide identity, while
            // _is_existing is only UI state. Resolve it immediately before
            // saving so barcode matches are edited rather than inserted.
            const productsByBarcode = new Map(
                products
                    .filter(product => String(product.barcode || '').trim())
                    .map(product => [String(product.barcode).trim().toLowerCase(), product])
            );
            const resolvedRows = bulkEditRows.map(row => {
                const barcodeKey = String(row.barcode || '').trim().toLowerCase();
                const matchingProduct = barcodeKey ? productsByBarcode.get(barcodeKey) : null;

                if (matchingProduct && Number(matchingProduct.id) !== Number(row.id)) {
                    return {
                        ...row,
                        id: Number(matchingProduct.id),
                        _is_existing: true,
                        _original_batch_no: matchingProduct.batch_no || '',
                        _original_barcode: matchingProduct.barcode || ''
                    };
                }
                return row;
            });

            // Separate resolved existing products (update) and truly new ones
            // (insert). The server also performs this upsert check, covering
            // products added by another user after this list was fetched.
            const existingProducts = resolvedRows.filter(row => row._is_existing && row.id);
            const newProducts = resolvedRows.filter(row => !row._is_existing || !row.id);

            // Prepare payload for existing products (edit_bulk)
            const updatePayload = existingProducts.length > 0 ? {
                action: 'edit_bulk',
                username: user.username,
                shop_id: currentShop.shop_id,
                products: existingProducts.map(row => ({
                    id: row.id,
                    date: row.date,
                    product_name: row.product_name,
                    warranty: row.warranty || '',
                    batch_no: row.batch_no,
                    barcode: row.barcode || '',
                    category: row.category,
                    company: row.company,
                    supplier_name: row.supplier_name,
                    supplier_id: row.supplier_id,
                    color: row.color,
                    size: row.size,
                    gunit: row.gunit,
                    cost_price_per_pack: row.cost_price_per_pack,
                    sell_price_per_unit: row.sell_price_per_unit,
                    profit_percent: row.profit_percent,
                    total_quantity: row.total_quantity,
                    quantity_alert: row.quantity_alert,
                    expiry_date: row.expiry_date,
                    packing_type: row.packing_type,
                    sub_packing_type: row.sub_packing_type,
                    items_per_pack: row.items_per_pack,
                    unit_of_measure: row.unit_of_measure
                }))
            } : null;

            // Prepare payload for new products (add_bulk)
            const addPayload = newProducts.length > 0 ? {
                action: 'add_bulk',
                username: user.username,
                shop_id: currentShop.shop_id,
                date: newProducts[0]?.date || new Date().toISOString().split('T')[0],
                product_name: newProducts[0]?.product_name || '',
                rq: newProducts.length,
                category: newProducts[0]?.category || '',
                company: newProducts[0]?.company || '',
                supplier_name: newProducts[0]?.supplier_name || '',
                cost_price_per_pack: newProducts[0]?.cost_price_per_pack || '0',
                profit_percent: newProducts[0]?.profit_percent || '',
                sell_price_per_unit: newProducts[0]?.sell_price_per_unit || '0',
                rows: newProducts.map(row => ({
                    batch_no: row.batch_no,
                    product_name: row.product_name,
                    total_quantity: row.total_quantity || '0',
                    barcode: row.barcode || '',
                    company: row.company || '',
                    supplier_name: row.supplier_name || ''
                }))
            } : null;

            // Execute updates
            let updateResult = null;
            let addResult = null;

            if (updatePayload) {
                const response = await fetch(PRODUCTS_API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatePayload)
                });
                updateResult = await response.json();
                if (updateResult.status !== 'success') {
                    throw new Error(updateResult.message || 'Failed to update existing products');
                }
            }

            if (addPayload) {
                const response = await fetch(PRODUCTS_API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(addPayload)
                });
                addResult = await response.json();
                if (addResult.status !== 'success') {
                    throw new Error(addResult.message || 'Failed to add new products');
                }
            }

            const totalUpdated = (updateResult?.updated_count || 0) + (addResult?.updated_count || 0);
            const totalAdded = addResult?.inserted_count || 0;
            const totalProducts = totalUpdated + totalAdded;

            showToast('success', `${totalProducts} product(s) processed successfully (${totalUpdated} updated, ${totalAdded} added)`);
            
            setShowBulkEditModal(false);
            setBulkEditRows([]);
            setBulkCommonFields({
                product_name: '',
                rq: '',
                category: '',
                company: '',
                supplier_name: '',
                cost_price_per_pack: '',
                profit_percent: '',
                sell_price_per_unit: ''
            });
            clearProductSelection();
            await fetchProducts();
        } catch (error) {
            console.error('Bulk product update failed:', error);
            showToast('error', error.message || 'Bulk update failed');
        } finally {
            setBulkActionLoading(false);
        }
    }, [currentShop, user?.username, bulkEditRows, products, validateBulkEditRows, showToast, clearProductSelection, fetchProducts]);

    // ============================================
    // DELETE FUNCTIONS
    // ============================================
    const handleDeleteClick = useCallback((productId) => {
        const product = products.find(p => p.id === productId);
        if (!product) return;
        if (!canManageProduct(product)) {
            showToast('error', 'You can only delete products you added');
            return;
        }
        setProductToDelete(productId);
        setShowDeleteModal(true);
    }, [products, canManageProduct, showToast]);

    const handleDelete = useCallback(async () => {
        if (!productToDelete || !currentShop) return;
        const product = products.find(p => p.id === productToDelete);
        if (!product || !canManageProduct(product)) {
            showToast('error', 'You can only delete your own products');
            setShowDeleteModal(false);
            setProductToDelete(null);
            return;
        }
        try {
            const response = await fetch(PRODUCTS_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    id: productToDelete,
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.deletedSuccess || 'Product deleted successfully');
                fetchProducts();
                setShowDeleteModal(false);
                setProductToDelete(null);
            } else {
                showToast('error', data.message || translations.deleteError || 'Error deleting product');
            }
        } catch (error) {
            console.error('Error deleting product:', error);
            showToast('error', translations.deleteError || 'Error deleting product');
        }
    }, [productToDelete, currentShop, products, user, translations, showToast, fetchProducts, canManageProduct]);

    const openSelectedDelete = useCallback(() => {
        if (selectedProducts.length === 0) {
            showToast('warning', 'Select at least one product first');
            return;
        }
        if (selectedProducts.length === 1) {
            handleDeleteClick(selectedProducts[0].id);
            return;
        }
        setShowBulkDeleteModal(true);
    }, [selectedProducts, handleDeleteClick, showToast]);

    const handleBulkDelete = useCallback(async () => {
        if (!currentShop || !user?.username || selectedProducts.length < 2) return;

        setBulkActionLoading(true);
        try {
            const response = await fetch(PRODUCTS_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete_bulk',
                    username: user.username,
                    shop_id: currentShop.shop_id,
                    ids: selectedProducts.map(product => Number(product.id))
                })
            });
            const data = await response.json();
            if (data.status !== 'success') throw new Error(data.message || 'Bulk delete failed');

            showToast('success', data.message || `${selectedProducts.length} products deleted successfully`);
            setShowBulkDeleteModal(false);
            clearProductSelection();
            await fetchProducts();
        } catch (error) {
            console.error('Bulk product delete failed:', error);
            showToast('error', error.message || 'Bulk delete failed');
        } finally {
            setBulkActionLoading(false);
        }
    }, [currentShop, user?.username, selectedProducts, showToast, clearProductSelection, fetchProducts]);

    // ============================================
    // SINGLE EDIT FORM VALIDATION & SUBMIT (kept for backward compatibility)
    // ============================================
    const validateEditForm = () => {
        const errors = {};
        if (!editFormData.product_name?.trim()) errors.product_name = translations.nameRequired || 'Product name is required';
        if (!editFormData.batch_no?.trim()) errors.batch_no = translations.batchRequired || 'Batch number is required';

        const costPrice = parseFloat(editFormData.cost_price_per_pack);
        if (isNaN(costPrice) || costPrice < 0) errors.cost_price_per_pack = translations.costPriceRequired || 'Cost price is required';

        const sellPrice = parseFloat(editFormData.sell_price_per_unit);
        if (isNaN(sellPrice) || sellPrice < 0) errors.sell_price_per_unit = translations.sellingPriceRequired || 'Selling price is required';

        const quantity = parseFloat(editFormData.total_quantity);
        if (isNaN(quantity) || quantity < 0) errors.total_quantity = translations.quantityRequired || 'Quantity is required';

        const alertQty = parseFloat(editFormData.quantity_alert);
        if (isNaN(alertQty) || alertQty < 0) errors.quantity_alert = translations.alertRequired || 'Low stock alert quantity is required';

        if (editFormData.expiry_date) {
            const expiry = new Date(editFormData.expiry_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (expiry < today) errors.expiry_date = translations.expiryPast || 'Expiry date cannot be in the past';
        }
        setEditFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleUpdateProduct = useCallback(async (e) => {
        e.preventDefault();
        if (!selectedProduct || !currentShop) {
            showToast('error', 'Product or shop information missing');
            return;
        }
        if (!canManageProduct(selectedProduct)) {
            showToast('error', 'You can only update your own product records');
            return;
        }
        if (!validateEditForm()) return;
        setEditLoading(true);
        try {
            const costPerPack = parseFloat(editFormData.cost_price_per_pack) || 0;
            const sellPricePerUnit = parseFloat(editFormData.sell_price_per_unit) || 0;
            const totalQuantity = parseFloat(editFormData.total_quantity) || 0;
            const alertQuantity = parseFloat(editFormData.quantity_alert) || 1;

            const itemsPerPack = parseFloat(editFormData.items_per_pack) || 1;
            const unitOfMeasure = editFormData.unit_of_measure || 'piece';

            const updateData = {
                action: 'edit',
                id: selectedProduct.id,
                shop_id: currentShop.shop_id,
                username: user.username,
                date: editFormData.date || selectedProduct.date,
                product_name: editFormData.product_name.trim(),
                warranty: editFormData.warranty?.trim() || '',
                product_code: selectedProduct.product_code || '',
                batch_no: editFormData.batch_no,
                category: editFormData.category,
                company: editFormData.company.trim(),
                supplier_name: editFormData.supplier_name,
                supplier_id: editFormData.supplier_id || null,
                color: editFormData.color,
                size: editFormData.size,
                gunit: editFormData.gunit,
                barcode: editFormData.barcode,
                quantity: totalQuantity,
                total_quantity: totalQuantity,
                quantity_alert: alertQuantity,
                expiry_date: editFormData.expiry_date || null,
                cost_price_per_pack: costPerPack,
                sell_price_per_unit: sellPricePerUnit,
                packing_type: editFormData.packing_type || 'packet',
                sub_packing_type: editFormData.sub_packing_type || 'piece',
                items_per_pack: itemsPerPack,
                unit_of_measure: unitOfMeasure
            };

            const response = await fetch(PRODUCTS_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updateData)
            });

            const responseText = await response.text();
            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error. Raw response:', responseText);
                throw new Error('Invalid JSON response from server');
            }

            if (data.status === 'success') {
                showToast('success', translations.productUpdated || 'Product updated successfully');
                fetchProducts();
                setShowEditModal(false);
                setSelectedProduct(null);
            } else {
                console.error('Server error response:', data);
                showToast('error', data.message || translations.updateError || 'Error updating product');
            }
        } catch (error) {
            console.error('Error updating product:', error);
            showToast('error', error.message || translations.updateError || 'Error updating product');
        } finally {
            setEditLoading(false);
        }
    }, [selectedProduct, currentShop, editFormData, user, translations, showToast, fetchProducts, validateEditForm, canManageProduct]);

    const handlePageChange = useCallback((page) => { if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); }, [pagination.totalPages]);

    const getStockStatus = (quantity, alert) => {
        const qty = parseFloat(quantity) || 0;
        const alertQty = parseFloat(alert) || 0;
        if (qty <= 0) return { status: 'out-of-stock', text: translations.outOfStock || 'Out of Stock', color: '#ef4444' };
        if (qty <= alertQty) return { status: 'low-stock', text: translations.lowStock || 'Low Stock', color: '#f59e0b' };
        return { status: 'in-stock', text: translations.inStock || 'In Stock', color: '#10b981' };
    };

    const getShopBadge = (product) => {
        if (product.is_product_centralized === 1) {
            const shopIds = product.centralized_shops || [];
            if (shopIds.length > 0) {
                return {
                    color: '#ff0000',
                    icon: faLink
                };
            }
        }
        return null;
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return '-';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // ============================================
    // HANDLE EDIT - Open bulk editor
    // ============================================
    const handleEdit = useCallback((product) => {
        if (!canManageProduct(product)) {
            showToast('error', 'You can only edit your own product records');
            return;
        }
        // Select the product first, then open bulk editor
        setSelectedProductIds([Number(product.id)]);
        // Small delay to ensure selection is updated
        setTimeout(() => {
            openBulkEditor(product);
        }, 100);
    }, [canManageProduct, showToast, openBulkEditor]);

    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>{translations.productList || 'Products List'}</h1>
                            <p>{translations.formDetails || 'All products details are below'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        {currentShop && (
                            <div className="ozlistui-header-search-wrapper">
                                <div className="ozlistui-floating-wrapper ozlistui-header-search">
                                    <input
                                        type="text"
                                        id="headerSearch"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            applyFilters();
                                        }}
                                        placeholder=" "
                                        className="ozlistui-header-search-input"
                                    />
                                    <label htmlFor="headerSearch">
                                        <FontAwesomeIcon icon={faSearch} />
                                        {translations.searchPlaceholder || 'Search products...'}
                                    </label>
                                </div>
                            </div>
                        )}

                        <button
                            className="ozlistui-header-filter-btn"
                            onClick={() => setShowFilters(!showFilters)}
                            title={showFilters ? "Hide Filters" : "Show Filters"}
                        >
                            <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                            <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                        </button>

                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <CustomDropdown
                            label={translations.filterBy || 'Filter By'}
                            icon={faTag}
                            value={filterBy}
                            onChange={setFilterBy}
                            options={filterByOptions}
                            translations={translations}
                        />

                        {filterBy === 'productName' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="productNameFilter"
                                        value={productNameFilter}
                                        onChange={(e) => setProductNameFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="productNameFilter">
                                        <FontAwesomeIcon icon={faBox} />
                                        {translations.productNameFilter || 'Product Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'category' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="categoryFilter"
                                        value={categoryFilter}
                                        onChange={(e) => setCategoryFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="categoryFilter">
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                        {translations.categoryFilter || 'Category'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'company' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="companyFilter"
                                        value={companyFilter}
                                        onChange={(e) => setCompanyFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="companyFilter">
                                        <FontAwesomeIcon icon={faBuilding} />
                                        {translations.companyFilter || 'Company Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'color' && (
                            <div className="ozlistui-filter-group">
                                <CustomDropdown
                                    label={translations.colorFilter || 'Color'}
                                    icon={faPalette}
                                    value={colorFilter}
                                    onChange={setColorFilter}
                                    options={colorOptions}
                                    translations={translations}
                                />
                            </div>
                        )}

                        {filterBy === 'size' && (
                            <div className="ozlistui-filter-group">
                                <CustomDropdown
                                    label={translations.sizeFilter || 'Size'}
                                    icon={faRulerCombined}
                                    value={sizeFilter}
                                    onChange={setSizeFilter}
                                    options={sizeOptions}
                                    translations={translations}
                                />
                            </div>
                        )}

                        {filterBy === 'batch' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="batchFilter"
                                        value={batchFilter}
                                        onChange={(e) => setBatchFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="batchFilter">
                                        <FontAwesomeIcon icon={faHashtag} />
                                        {translations.batchFilter || 'Batch Number'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'barcode' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="barcodeFilter"
                                        value={barcodeFilter}
                                        onChange={(e) => setBarcodeFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="barcodeFilter">
                                        <FontAwesomeIcon icon={faBarcode} />
                                        {translations.barcodeFilter || 'Barcode'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'added_by' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="addedByFilter"
                                        value={addedByFilter}
                                        onChange={(e) => setAddedByFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="addedByFilter">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations.addedByFilter || 'Added By'}
                                    </label>
                                </div>
                            </div>
                        )}

                        <CustomDropdown
                            label={translations.stockStatus || 'Stock Status'}
                            icon={faExclamationTriangle}
                            value={stockStatusFilter}
                            onChange={setStockStatusFilter}
                            options={stockStatusOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.orientation || 'Orientation'}
                            icon={faFilePdf}
                            value={pdfOrientation}
                            onChange={setPdfOrientation}
                            options={pdfOrientationOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.pageSize || 'Page Size'}
                            icon={faFilePdf}
                            value={pdfPageSize}
                            onChange={setPdfPageSize}
                            options={pdfPageSizeOptions}
                            translations={translations}
                        />

                        <div className="ozlistui-filter-group">
                            <button onClick={fetchProducts} className="ozlistui-refresh-btn" disabled={loading}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button
                                onClick={exportToPDF}
                                className="ozlistui-refresh-btn"
                                disabled={filteredProducts.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your product data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view products'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    {/* Summary Cards */}
                    <div className="ozlistui-summary-cards">
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
                                <FontAwesomeIcon icon={faBoxes} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.length}</h3>
                                <p>{translations.totalProducts || 'Total Products'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#10b98120', color: '#10b981' }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q > a; }).length}</h3>
                                <p>{translations.inStock || 'In Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q <= a && q > 0; }).length}</h3>
                                <p>{translations.lowStock || 'Low Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#ef444420', color: '#ef4444' }}>
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); return q <= 0; }).length}</h3>
                                <p>{translations.outOfStock || 'Out of Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#8b5cf620', color: '#8b5cf6' }}>
                                <FontAwesomeIcon icon={faCreditCard} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{formatCurrency(totalStockValue)}</h3>
                                <p>{translations.stockValue || 'Stock Value'}</p>
                            </div>
                        </div>
                    </div>

                    <div className={`ozlistui-selection-toolbar ${selectedProducts.length > 0 ? 'ozlistui-has-selection' : ''}`}>
                        <div className="ozlistui-selection-summary">
                            <strong>{selectedProducts.length}</strong>
                            <span>{selectedProducts.length === 1 ? 'product selected' : 'products selected'}</span>
                            <small>Similar product names are grouped together automatically.</small>
                        </div>
                        <div className="ozlistui-selection-actions">
                            <button
                                type="button"
                                className="ozlistui-btn ozlistui-btn-secondary"
                                onClick={clearProductSelection}
                                disabled={selectedProducts.length === 0 || bulkActionLoading}
                            >
                                <FontAwesomeIcon icon={faTimes} /> Clear
                            </button>
                            <button
                                type="button"
                                className="ozlistui-btn ozlistui-btn-primary"
                                onClick={() => openBulkEditor()}
                                disabled={selectedProducts.length === 0 || bulkActionLoading}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                                {selectedProducts.length > 1 ? `Edit ${selectedProducts.length} Products` : 'Edit Selected'}
                            </button>
                            <button
                                type="button"
                                className="ozlistui-btn ozlistui-btn-delete"
                                onClick={openSelectedDelete}
                                disabled={selectedProducts.length === 0 || bulkActionLoading}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                                {selectedProducts.length > 1 ? `Delete ${selectedProducts.length} Products` : 'Delete Selected'}
                            </button>
                        </div>
                    </div>

                    <div className="ozlistui-table-scroll">
                        <div className="ozlistui-table-container">
                            <div className="ozlistui-table-wrapper">
                                <table className="ozlistui-table">
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-selection-column ozlistui-centered-cell">
                                                <input
                                                    type="checkbox"
                                                    className="ozlistui-row-checkbox"
                                                    aria-label="Select all editable products on this page"
                                                    checked={allManageableOnPageSelected}
                                                    ref={input => {
                                                        if (input) {
                                                            const selectedOnPage = manageableProductsOnPage.some(product => selectedProductIdSet.has(Number(product.id)));
                                                            input.indeterminate = selectedOnPage && !allManageableOnPageSelected;
                                                        }
                                                    }}
                                                    onChange={toggleCurrentPageSelection}
                                                    disabled={manageableProductsOnPage.length === 0}
                                                />
                                            </th>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{translations.serialNo || 'S.No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.productName || 'Product Name'}</th>
                                            <th className="ozlistui-centered-cell" style={{ width: '1%', whiteSpace: 'nowrap' }}>{translations.warranty || 'Warranty'}</th>
                                            <th className="ozlistui-centered-cell">{translations.batchNumber || 'Batch'}</th>
                                            <th className="ozlistui-centered-cell">{translations.barcode || 'Barcode'}</th>
                                            <th className="ozlistui-centered-cell">{translations.category || 'Category'}</th>
                                            <th className="ozlistui-centered-cell">{translations.company || 'Company'}</th>
                                            <th className="ozlistui-centered-cell">{translations.supplierName || 'Supplier'}</th>
                                            <th className="ozlistui-centered-cell">{translations.costPerUnit || 'Cost/Unit'}</th>
                                            <th className="ozlistui-centered-cell">{translations.sellPerUnit || 'Price/Unit'}</th>
                                            <th className="ozlistui-centered-cell">{translations.totalQuantity || 'Qty'}</th>
                                            <th className="ozlistui-centered-cell">{translations.expiryDate || 'Expiry'}</th>
                                            <th className="ozlistui-centered-cell">{translations.stockStatus || 'Status'}</th>
                                            <th className="ozlistui-centered-cell">{translations.stockValue || 'Stock Value'}</th>
                                            <th className="ozlistui-centered-cell">{translations.added_by_username || 'Added By'}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{translations.actions || 'Actions'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagination.currentProducts.map((product, index) => {
                                            const addedBy = product.added_by_username || product.username || '-';
                                            const isSelfAdded = canManageProduct(product);
                                            const isSelected = selectedProductIdSet.has(Number(product.id));
                                            const stockStatus = getStockStatus(product.quantity, product.quantity_alert);
                                            const shopBadge = getShopBadge(product);
                                            const costPerUnit = parseFloat(
                                                product.cost_per_unit ||
                                                product.costPerUnit ||
                                                product.unit_cost ||
                                                (product.cost_per_pack / (product.items_per_pack || 1)) ||
                                                0
                                            );
                                            const totalQty = parseFloat(product.quantity || 0);
                                            const stockValue = costPerUnit * totalQty;

                                            return (
                                                <tr key={product.id} className={isSelected ? 'ozlistui-selected' : ''}>
                                                    <td className="ozlistui-selection-cell ozlistui-centered-cell">
                                                        <input
                                                            type="checkbox"
                                                            className="ozlistui-row-checkbox"
                                                            aria-label={`Select ${product.product_name || 'product'}`}
                                                            checked={isSelected}
                                                            onChange={() => toggleProductSelection(product)}
                                                            disabled={!isSelfAdded}
                                                            title={isSelfAdded ? 'Select product' : 'Only products added by you in this shop can be selected'}
                                                        />
                                                    </td>
                                                    <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <div className="ozlistui-product-name-wrapper">
                                                            <span className="ozlistui-cell-text ozlistui-product-name">
                                                                {product.product_name || '-'}
                                                            </span>
                                                            {shopBadge && (
                                                                <span
                                                                    className={`ozlistui-centralized-badge ${product.is_product_centralized === 1 ? 'ozlistui-linked' : ''}`}
                                                                    style={{
                                                                        backgroundColor: shopBadge.color + '20',
                                                                        color: shopBadge.color
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faLink}
                                                                        className={`ozlistui-link-icon ${product.is_product_centralized === 1 ? 'ozlistui-linked' : 'ozlistui-unlinked'}`}
                                                                    />
                                                                    <span className="ozlistui-badge-text"> Centralized</span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="ozlistui-centered-cell" style={{ width: '1%', whiteSpace: 'nowrap' }}>
                                                        <span className="ozlistui-cell-text" style={{
                                                            color: product.warranty ? '#2563eb' : '#9ca3af',
                                                            fontWeight: product.warranty ? '500' : 'normal'
                                                        }}>{product.warranty || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.batch_no || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.barcode || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.category || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.company || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.supplier_name || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatCurrency(costPerUnit)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatCurrency(product.sell_price_per_unit)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className={`ozlistui-cell-text ${stockStatus.status === 'low-stock' ? 'ozlistui-low-stock' : stockStatus.status === 'out-of-stock' ? 'ozlistui-out-of-stock' : ''}`}>
                                                            {parseFloat(product.quantity || 0).toFixed(2)}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatDate(product.expiry_date)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-stock-badge" style={{ backgroundColor: stockStatus.color + '20', color: stockStatus.color }}>
                                                            {stockStatus.text}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>
                                                            {formatCurrency(stockValue)}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: '#010000', fontWeight: 'bold' }}>
                                                            {addedBy}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                        <div className="ozlistui-actions-content">
                                                            <button onClick={() => handleView(product)} className="ozlistui-action-btn ozlistui-view-btn" title={translations.view || 'View'}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </button>
                                                            <button onClick={() => handleEdit(product)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'} disabled={!isSelfAdded}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                            <button onClick={() => handleDeleteClick(product.id)} className="ozlistui-action-btn ozlistui-delete-btn" title={translations.delete || 'Delete'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {filteredProducts.length > 0 && currentShop && (
                        <div className="ozlistui-pagination">
                            <div className="ozlistui-pagination-left">
                                <div className="ozlistui-per-page">
                                    <span>{translations.show || 'Show'}</span>
                                    <select
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(Number(e.target.value));
                                            setCurrentPage(1);
                                        }}
                                        className="ozlistui-per-page-select"
                                    >
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={500}>500</option>
                                        <option value={1000}>1000</option>
                                    </select>
                                    <span>{translations.perPage || 'per page'}</span>
                                </div>
                                <div className="ozlistui-pagination-info">
                                    <span>
                                        {translations.showing || 'Showing'}
                                        <strong> {pagination.startIndex + 1} </strong>
                                        {translations.to || 'to'}
                                        <strong> {Math.min(pagination.startIndex + itemsPerPage, filteredProducts.length)} </strong>
                                        {translations.of || 'of'}
                                        <strong> {filteredProducts.length} </strong>
                                        {translations.products || 'products'}
                                    </span>
                                </div>
                            </div>
                            <div className="ozlistui-pagination-right">
                                <button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className="ozlistui-pagination-btn"
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    <span>{translations.previous || 'Previous'}</span>
                                </button>
                                <div className="ozlistui-page-numbers">
                                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (pagination.totalPages <= 5) {
                                            pageNum = i + 1;
                                        } else if (currentPage <= 3) {
                                            pageNum = i + 1;
                                        } else if (currentPage >= pagination.totalPages - 2) {
                                            pageNum = pagination.totalPages - 4 + i;
                                        } else {
                                            pageNum = currentPage - 2 + i;
                                        }
                                        return (
                                            <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                </div>
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === pagination.totalPages}
                                    className="ozlistui-pagination-btn"
                                >
                                    <span>{translations.next || 'Next'}</span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* View Modal */}
            {showViewModal && selectedProduct && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faBox} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.productDetails || 'Product Details'}</h3>
                                <span className="ozlistui-product-number-badge">#{selectedProduct.id}</span>
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body ozlistui-view-modal-body">
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faBox} />{translations.productDetails || 'Product Summary'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.productName || 'Product Name'}:</span><span className="ozlistui-view-value">{selectedProduct.product_name || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.warranty || 'Warranty'}:</span><span className="ozlistui-view-value">{selectedProduct.warranty || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.batchNumber || 'Batch Number'}:</span><span className="ozlistui-view-value">{selectedProduct.batch_no || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.barcode || 'Barcode'}:</span><span className="ozlistui-view-value">{selectedProduct.barcode || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.category || 'Category'}:</span><span className="ozlistui-view-value">{selectedProduct.category || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.company || 'Company'}:</span><span className="ozlistui-view-value">{selectedProduct.company || '-'}</span></div>
                                    <div className="ozlistui-view-row">
                                        <span className="ozlistui-view-label">{translations.supplierName || 'Supplier'}:</span>
                                        <span className="ozlistui-view-value">{selectedProduct.supplier_name || '-'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faCreditCard} />{translations.stockInfo || 'Stock Information'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.costPerUnit || 'Cost Per Unit'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.cost_per_unit)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.sellPerUnit || 'Sell Price Per Unit'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.sell_price_per_unit)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.sellPerPack || 'Sell Price Per Pack'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.sell_per_pack)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.totalQuantity || 'Total Quantity'}:</span><span className="ozlistui-view-value">{parseFloat(selectedProduct.quantity || 0).toFixed(2)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.lowStockAlert || 'Low Stock Alert'}:</span><span className="ozlistui-view-value">{parseFloat(selectedProduct.quantity_alert || 0).toFixed(2)}</span></div>
                                    {selectedProduct.expiry_date && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.expiryDate || 'Expiry Date'}:</span><span className="ozlistui-view-value">{formatDate(selectedProduct.expiry_date)}</span></div>
                                    )}
                                    {(() => {
                                        const costPerUnit = parseFloat(
                                            selectedProduct.cost_per_unit ||
                                            selectedProduct.costPerUnit ||
                                            selectedProduct.unit_cost ||
                                            (selectedProduct.cost_per_pack / (selectedProduct.items_per_pack || 1)) ||
                                            0
                                        );
                                        const totalQty = parseFloat(selectedProduct.quantity || 0);
                                        const stockVal = costPerUnit * totalQty;
                                        return (
                                            <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.stockValue || 'Stock Value'}:</span><span className="ozlistui-view-value" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>{formatCurrency(stockVal)}</span></div>
                                        );
                                    })()}
                                </div>
                            </div>
                            <div className="ozlistui-view-section ozlistui-metadata-section">
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.addedBy || 'Added By'}:</span><span className="ozlistui-view-value"><span className="ozlistui-added-by-badge">{selectedProduct.added_by_username || selectedProduct.username || '-'}</span></span></div>
                                    {selectedProduct.date && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.dateAdded || 'Date Added'}:</span><span className="ozlistui-view-value">{formatDate(selectedProduct.date)}</span></div>
                                    )}
                                    {selectedProduct.shop_name && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.shopInfo || 'Shop'}:</span><span className="ozlistui-view-value">{selectedProduct.shop_name}</span></div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                            <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handleEdit(selectedProduct); }}>
                                <FontAwesomeIcon icon={faEdit} />
                                {translations.edit || 'Edit'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Bulk Edit Modal with Common Fields */}
            {showBulkEditModal && (
                <div className="ozlistui-modal-overlay" onClick={(event) => event.stopPropagation()}>
                    <div
                        className="ozlistui-modal-content ozlistui-bulk-edit-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="bulk-edit-title"
                        onClick={(event) => event.stopPropagation()}
                        style={{
                            width: '95vw',
                            maxWidth: '1400px',
                            maxHeight: '90vh'
                        }}
                    >
                        <form onSubmit={handleBulkEditSubmit}>
                            <div className="ozlistui-modal-header">
                                <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faBoxesIcon} /></div>
                                <div className="ozlistui-modal-title">
                                    <h3 id="bulk-edit-title">{translations.bulkEdit || 'Bulk Edit Products'}</h3>
                                    <span className="ozlistui-product-number-badge">{bulkEditRows.length} rows</span>
                                </div>
                                <button
                                    type="button"
                                    className="ozlistui-close-btn"
                                    onClick={() => setShowBulkEditModal(false)}
                                    disabled={bulkActionLoading}
                                    aria-label="Close bulk editor"
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            </div>

                            {/* Common Fields Section */}
                            <div className="ozlistui-bulk-common-fields">
                                <div className="ozlistui-bulk-common-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="bulk_common_product_name"
                                                value={bulkCommonFields.product_name}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, product_name: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_product_name">
                                                <FontAwesomeIcon icon={faBox} />
                                                {translations.productName || 'Product Name'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="bulk_common_rq"
                                                value={bulkCommonFields.rq}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    setBulkCommonFields(prev => ({ ...prev, rq: val }));
                                                    handleRQChange(val);
                                                }}
                                                placeholder=" "
                                                min="1"
                                                step="1"
                                                className={bulkCommonErrors.rq ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="bulk_common_rq">
                                                <FontAwesomeIcon icon={faHashtag} />
                                                {translations.rqRows || 'RQ (Rows)'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {bulkCommonErrors.rq && (
                                            <div className="ozlistui-error-message">{bulkCommonErrors.rq}</div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="bulk_common_category"
                                                value={bulkCommonFields.category}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, category: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_category">
                                                <FontAwesomeIcon icon={faLayerGroup} />
                                                {translations.category || 'Category'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="bulk_common_company"
                                                value={bulkCommonFields.company}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, company: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_company">
                                                <FontAwesomeIcon icon={faBuilding} />
                                                {translations.company || 'Company / Brand'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="bulk_common_supplier_name"
                                                value={bulkCommonFields.supplier_name}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, supplier_name: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_supplier_name">
                                                <FontAwesomeIcon icon={faTruck} />
                                                {translations.supplierName || 'Supplier Name'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.01"
                                                id="bulk_common_cost_price"
                                                value={bulkCommonFields.cost_price_per_pack}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, cost_price_per_pack: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_cost_price">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                {translations.costPerPack || 'Cost Price'}
                                                <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.01"
                                                id="bulk_common_profit_percent"
                                                value={bulkCommonFields.profit_percent}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, profit_percent: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_profit_percent">
                                                <FontAwesomeIcon icon={faPercent} />
                                                {translations.profitMargin || 'Profit %'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.01"
                                                id="bulk_common_sell_price"
                                                value={bulkCommonFields.sell_price_per_unit}
                                                onChange={(e) => setBulkCommonFields(prev => ({ ...prev, sell_price_per_unit: e.target.value }))}
                                                placeholder=" "
                                            />
                                            <label htmlFor="bulk_common_sell_price">
                                                <FontAwesomeIcon icon={faTag} />
                                                {translations.sellPerUnit || 'Sell Price'}
                                                <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="ozlistui-bulk-common-actions">
                                    <button
                                        type="button"
                                        className="ozlistui-btn ozlistui-btn-primary ozlistui-apply-common-btn"
                                        onClick={applyCommonFieldsToRows}
                                    >
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                        {translations.applyToAll || 'Apply to all selected products'}
                                    </button>
                                    <button
                                        type="button"
                                        className="ozlistui-btn ozlistui-btn-secondary"
                                        onClick={addNewRow}
                                    >
                                        <FontAwesomeIcon icon={faPlusCircle} />
                                        Add Row
                                    </button>
                                </div>
                            </div>

                            <div className="ozlistui-bulk-edit-note">
                                Edit individual cells below. Common fields applied above will update all rows.
                                <span className="ozlistui-bulk-note-highlight">
                                    {bulkEditRows.filter(r => r._is_existing).length} existing, {bulkEditRows.filter(r => !r._is_existing).length} new
                                </span>
                            </div>

                            {Object.keys(bulkEditErrors).length > 0 && (
                                <div className="ozlistui-bulk-error-summary">
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                    Fix the highlighted cells before saving.
                                </div>
                            )}

                            <div className="ozlistui-bulk-edit-table-wrap">
                                <table className="ozlistui-bulk-edit-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40px' }}>Sr</th>
                                            <th>Date</th>
                                            <th>Product Name</th>
                                            <th>Warranty</th>
                                            <th>Batch No</th>
                                            <th>Barcode</th>
                                            <th>Category</th>
                                            <th>Company</th>
                                            <th>Supplier</th>
                                            <th>Cost / Pack</th>
                                            <th>Profit %</th>
                                            <th>Sell / Unit</th>
                                            <th>Quantity</th>
                                            <th>Expiry</th>
                                            <th style={{ width: '50px' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bulkEditRows.map((row, index) => {
                                            const cell = (field) => bulkEditErrors[`${index}.${field}`];
                                            const isExisting = row._is_existing;
                                            
                                            const inputProps = (field) => ({
                                                value: row[field] ?? '',
                                                onChange: event => updateBulkEditRow(index, field, event.target.value),
                                                className: cell(field) ? 'ozlistui-bulk-input-error' : '',
                                                title: cell(field) || '',
                                                'aria-invalid': Boolean(cell(field))
                                            });

                                            return (
                                                <tr key={index} className={isExisting ? 'ozlistui-existing-row' : 'ozlistui-new-row'}>
                                                    <td className="ozlistui-bulk-row-number">
                                                        {index + 1}
                                                        {!isExisting && <span className="ozlistui-new-badge">NEW</span>}
                                                    </td>
                                                    <td><input type="date" {...inputProps('date')} /></td>
                                                    <td><input type="text" {...inputProps('product_name')} /></td>
                                                    <td><input type="text" {...inputProps('warranty')} /></td>
                                                    <td><input type="text" {...inputProps('batch_no')} /></td>
                                                    <td><input type="text" {...inputProps('barcode')} placeholder={isExisting ? "Required" : "Scan later"} /></td>
                                                    <td><input type="text" {...inputProps('category')} /></td>
                                                    <td><input type="text" {...inputProps('company')} /></td>
                                                    <td><input type="text" {...inputProps('supplier_name')} /></td>
                                                    <td><input type="number" min="0" step="any" {...inputProps('cost_price_per_pack')} /></td>
                                                    <td><input type="number" min="0" step="any" {...inputProps('profit_percent')} /></td>
                                                    <td><input type="number" min="0" step="any" {...inputProps('sell_price_per_unit')} /></td>
                                                    <td><input type="number" min="0" step="any" {...inputProps('total_quantity')} /></td>
                                                    <td><input type="date" {...inputProps('expiry_date')} /></td>
                                                    <td>
                                                        {!isExisting && (
                                                            <button
                                                                type="button"
                                                                className="ozlistui-remove-row-btn"
                                                                onClick={() => removeRow(index)}
                                                                title="Remove this row"
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        )}
                                                        {isExisting && (
                                                            <span className="ozlistui-existing-label">Existing</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            <div className="ozlistui-modal-footer">
                                <span className="ozlistui-bulk-footer-count">
                                    {bulkEditRows.length} row(s) · 
                                    {bulkEditRows.filter(r => r._is_existing).length} existing · 
                                    {bulkEditRows.filter(r => !r._is_existing).length} new
                                </span>
                                <button
                                    type="button"
                                    className="ozlistui-btn ozlistui-btn-secondary"
                                    onClick={() => setShowBulkEditModal(false)}
                                    disabled={bulkActionLoading}
                                >
                                    <FontAwesomeIcon icon={faTimes} /> Cancel
                                </button>
                                <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={bulkActionLoading}>
                                    {bulkActionLoading
                                        ? <><div className="ozlistui-btn-spinner"></div> Processing...</>
                                        : <><FontAwesomeIcon icon={faSave} /> Save All Changes</>}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Multi-product delete confirmation */}
            {showBulkDeleteModal && (
                <div className="ozlistui-modal-overlay" onClick={(event) => event.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>Delete {selectedProducts.length} Products?</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowBulkDeleteModal(false)} disabled={bulkActionLoading}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>All selected products will be deleted together. This action cannot be undone.</p>
                                <ul className="ozlistui-bulk-delete-list">
                                    {selectedProducts.slice(0, 8).map(product => (
                                        <li key={product.id}>{product.product_name} — {product.batch_no || 'No batch'}</li>
                                    ))}
                                    {selectedProducts.length > 8 && <li>+ {selectedProducts.length - 8} more product(s)</li>}
                                </ul>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowBulkDeleteModal(false)} disabled={bulkActionLoading}>
                                <FontAwesomeIcon icon={faTimes} /> Cancel
                            </button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleBulkDelete} disabled={bulkActionLoading}>
                                {bulkActionLoading
                                    ? <><div className="ozlistui-btn-spinner"></div> Deleting...</>
                                    : <><FontAwesomeIcon icon={faTrash} /> Delete All Selected</>}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>{translations.deleteMessage || 'Are you sure you want to delete this product?'}</p>
                                <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CosmeticsProductsList;
